module.exports = __webpack_public_path__ + "static/media/flexible-payment-card@2x.026202b5.jpg";